import Cookies, { CookieAttributes } from 'js-cookie';
import Region from 'types/Region';

const COOKIE_COUNTRY_NAME = 'GEO_COUNTRY_2024_04';
const COOKIE_INTENT_REGION = 'GEO_INTENT_2024_04';
const COOKIE_AUTO_REDIRECT = 'GEO_REDIRECT_2024_04';
const COOKIE_SETTINGS = <CookieAttributes>{
  domain: 'rains.com',
  expires: 30,
};

const EU_COUNTRIES = [
  'at',
  'be',
  'bg',
  'cy',
  'cz',
  'de',
  'dk',
  'ee',
  'es',
  'fi',
  'fr',
  'gr',
  'gb',
  'hu',
  'hr',
  'ie',
  'it',
  'lt',
  'lu',
  'lv',
  'mt',
  'pl',
  'pt',
  'nl',
  'ro',
  'se',
  'si',
  'sk',
  'cn',
  'us',
];

export const getCountryIntent = async (): Promise<string> => {
  const countryCookie = Cookies.get(COOKIE_COUNTRY_NAME);

  if (countryCookie) {
    return countryCookie;
  }

  const response = await fetch('https://get.geojs.io/v1/ip/country.json');
  const body = await response.json();

  Cookies.set(COOKIE_COUNTRY_NAME, body.country.toLowerCase(), COOKIE_SETTINGS);

  return body.country.toLowerCase();
};

export const getRegionIntent = (intent: string): Region => {
  const regionMatch = theme.regions.find((region) => {
    const intentRegionCookie = Cookies.get(COOKIE_INTENT_REGION);

    if (intentRegionCookie) {
      return region.domain === intentRegionCookie;
    }

    return region.regions?.includes(intent);
  });

  if (regionMatch) {
    return regionMatch;
  }

  // Return default
  return theme.regions.find((region) => region.default);
};

export const getCurrentRegion = () =>
  theme.regions.find((region) => region.domain === Shopify.shop);

export const setRegionIntent = (region: Region) => {
  Cookies.set(COOKIE_INTENT_REGION, region.domain, COOKIE_SETTINGS);
  Cookies.set(COOKIE_AUTO_REDIRECT, 'true', COOKIE_SETTINGS);
};

export const shouldAutoRedirect = (intent: string) =>
  Cookies.get(COOKIE_AUTO_REDIRECT) || !EU_COUNTRIES.includes(intent);

export default {
  getCountryIntent,
  getCurrentRegion,
  getRegionIntent,
};
